import React from "react";
import Moment from "react-moment";

import { connect } from "react-redux";

import PurchaseService from "services/purchase";
import { update, create, remove } from "reducers/purchase";

import { setBreadcrumbs } from "reducers/view";

import ZeeTable from "components/ZeeTable";
import Button from "@material-ui/core/Button";

import IconButton from "@material-ui/core/IconButton";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import EmailIcon from "@material-ui/icons/Email";
import ArticleIcon from "@material-ui/icons/Description";

import DocumentExport from "../Document/Export";

import { Base64 } from "js-base64";

import { gapi } from "gapi-script";

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () =>
      resolve(reader.result.replace("data:application/pdf;base64,", ""));
    reader.onerror = (error) => reject(error);
  });

class GMailApi {
  async createDraft(to, subject, body, files) {
    const payload = await this.payload(to, subject, body, files);

    gapi.load("client", () => {
      gapi.client.load("gmail", "v1", () => {
        const request = gapi.client.gmail.users.drafts.create({
          userId: "me",
          resource: {
            message: {
              raw: Base64.encode(payload),
            },
          },
        });

        request.execute((response) => console.log("callback", response));
      });
    });
  }

  async payload(to, subject, body, files = []) {
    const boundary = "negairscs20";

    const attachments = await Promise.all(
      await files.reduce(async (agg, file) => {
        return [
          ...agg,
          `Content-Type: ${file.type}; charset=UTF-8; name="${file.name}"\r`,
          `Content-Disposition: attachment; filename="${file.name}"\r`,
          `Content-Transfer-Encoding: base64\r\n\r'`,
          `${file.text}\r`,
          `--${boundary}\r`,
        ];
      }, [])
    );

    const raw = [
      `To: ${to}`,
      `Subject: ${subject}`,
      `Content-Type: multipart/mixed; boundary=${boundary}\r\n\r`,
      // `--${boundary}\r`,
      // `Content-Type: text/plain; charset=UTF-8\r\n\r`,
      // `${message.body.text}\r`,
      `--${boundary}\r`,
      `Content-Type: text/html; charset=UTF-8\r\n\r`,
      `${body}\r`,
      `--${boundary}\r`,
      ...attachments,
    ];

    return raw.join("\n");
  }
}

class PurchasesActions extends DocumentExport {
  get row() {
    return this.props.row;
  }

  get document() {
    return this.props.getPurchaseDocument(this.row);
  }

  async onEmailClick() {
    const document = await this.getPdfDataFile();
    document.text = await toBase64(document);

    const { supplier } = this.document;

    const to = supplier.email;
    const subject = `NegAir - Purchase Order - ${this.document.id}`;
    const body = `
    <p>Dear ${supplier.name}</p>
    <p>Please find the attached purchase order</p>
    ${this.renderToString({ hasHeader: false })}
    <p>Kindest regards</p>
    <p>James</p>`;

    const files = [document];

    const gmail = new GMailApi();
    gmail.createDraft(to, subject, body, files);
  }

  render() {
    return (
      <React.Fragment>
        {/* Download */}
        <IconButton size="small" onClick={(e) => this.onClick()}>
          <ArticleIcon />
        </IconButton>
        {/* Create email with draft */}
        <IconButton size="small" onClick={(e) => this.onEmailClick()}>
          <EmailIcon />
        </IconButton>
      </React.Fragment>
    );
  }
}

class Purchases extends React.Component {
  purchaseService = new PurchaseService();

  constructor() {
    super(...arguments);
    this.props.setBreadcrumbs([{ name: "Purchases", slug: "/purchases" }]);
  }

  getPurchaseId(row) {
    const year = new Date(row.date * 1000).getFullYear().toString().substr(-2);
    const id = row.id.padStart(3, "0");
    return `${year}${id}`;
  }

  getPurchaseValue(row) {
    return this.props.purchaseItem
      .filter((item) => item.purchase_id === row.id)
      .map((item) => this.getSubtotal(item))
      .reduce((a, b) => a + b, 0)
      .toFixed(2);
  }

  getSubtotal(row) {
    const discount = row.discount > 0 ? row.discount / 100 : null;
    const price = row.price;
    const quantity = row.quantity > 0 ? row.quantity : 1;

    if (!price) {
      return 0;
    }

    const total = price * quantity;

    if (discount) {
      // return total - total * discount;
    }

    return total;
  }

  state = {
    data: null,
  };

  columns = {
    id: {
      name: "Purchase Id",
      format: (id, row) => this.getPurchaseId(row),
    },
    supplier: {
      name: "Supplier",
      format: (id, row) => {
        const supplier = this.props.supplier.find(
          (item) => item.id === row.supplier_id
        );

        return supplier.name;
      },
    },
    value: {
      name: "Value",
      format: (value, row) => this.getPurchaseValue(row),
    },
    date: {
      name: "Date",
      format: (unix) =>
        unix && (
          <Moment unix format="DD/MM/YY HH:mm:ss">
            {unix}
          </Moment>
        ),
    },
  };

  get data() {
    return this.props.purchases;
  }

  onCreate() {
    this.props.history.push("/purchases/create");
  }

  async onDelete(purchase) {
    const result = await this.purchaseService
      .delete(purchase)
      .then(({ data }) => data);
    if (result.success) {
      this.props.remove(result.data);
      return result.data;
    }
    return false;
  }

  onRowDoubleClick(purchase) {
    const { history } = this.props;
    history.push(`/purchases/${purchase.id}`);
  }

  getAddress({
    name,
    address1,
    address2,
    address3,
    address4,
    address5,
    address6,
    address7,
    address8,
    address9,
    address10,
  }) {
    return [
      name,
      address1,
      address2,
      address3,
      address4,
      address5,
      address6,
      address7,
      address8,
      address9,
      address10,
    ];
  }

  getPurchaseDocument(row) {
    const supplier = this.props.supplier.find(
      (item) => item.id === row.supplier_id
    );

    return {
      id: this.getPurchaseId(row),
      date: row.date,
      reference: row.reference,
      title: "Purchase Order",
      type: "purchase",
      addressTo: [
        // Supplier
        ...this.getAddress(supplier),
      ],
      addressFrom: [
        "NegAir Limited",
        "Unit 23",
        "Manningford Centre",
        "Manningford Bohune",
        "Pewsey",
        "Wiltshire",
        "SN9 6NL",
      ],
      items: this.props.purchaseItem
        .filter((item) => item.purchase_id === row.id)
        .map((item) => ({
          ...item,
          ...this.getAdditionalItem(item),
          subtotal: this.getSubtotal(item),
        })),
      total: this.getPurchaseValue(row),
      supplier,
    };
  }

  getAdditionalItem(item) {
    return {
      description: this.props.stock.find((stock) => stock.id === item.stock_id)
        .name,
    };
  }

  render() {
    return (
      <React.Fragment>
        <ZeeTable
          title="Purchases"
          columns={this.columns}
          data={this.data}
          hasPagination={true}
          hasSort={true}
          hasDelete={true}
          hasSearch={true}
          purchaseBy="name"
          onDelete={(supplier) => this.onDelete(supplier)}
          onRowDoubleClick={(purchase) => this.onRowDoubleClick(purchase)}
          actionComponent={PurchasesActions}
          getPurchaseDocument={(row) => this.getPurchaseDocument(row)}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => this.onCreate()}
        >
          Create
        </Button>
      </React.Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      stock: state.stock.all,
      supplier: state.supplier.all,
      purchases: state.purchase.all,
      purchaseItem: state.purchase.item.all,
    };
  },
  { update, create, remove, setBreadcrumbs }
)(Purchases);
